 

<!-- [ngStyle]="{ display: merchantFromLocalstorage ? 'none' : 'block' }" -->
  <nz-select  [nzAllowClear]="true" style="padding-left: 5px;"
  [hidden]="merchantFromLocalstorage ? true : false"
  (ngModelChange)="click($event)" [ngModel]="selectedValue" nzPlaceHolder="Select a merchant" nzShowSearch
  [nzLoading]="isLoading">
  <nz-option *ngFor="let merchant of merchants" [nzValue]="merchant.id" [nzLabel]="merchant.name"></nz-option>
</nz-select>